export default __webpack_public_path__ + "0bf78a15101f3fdda406d437f7bf5160.svg";